import PropTypes from 'prop-types';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';

import classnames from 'classnames';

import { useHeader, withWidget } from '@ezbobdev/ui-commons';
import { useTranslation } from '@ezbobdev/ui-framework';

import { interpolateString } from '../../Utils/helpers';
import { LanguageSelect, MaterialContainer, MaterialLink, MaterialToolbar, MaterialTypography } from '../../index';
import { AppBar, Content, LogosWrapper, MenuWrapper, NavLinkStyled, SubMenuWrapper } from './MaterialAppBar.styled';
import MaterialAppBarActions from './MaterialAppBarActions';

const MaterialAppBar = (props) => {
  const { children, containerMaxWidth, containerBoxShadow, actions, helpType } = props;

  const {
    className,
    logo,
    isLogoCentered,
    secondaryLogo,
    position,
    disableGutters,
    variant,
    elevation,
    color,
    alloWMultilanguages,
    menu,
    configByName,
    isLogoClickable,
    hasLogoutButton,
    customerWizardRoute,
    help,
    exit,
    phone,
    showAtLeastOneLogo,
  } = useHeader(props, MaterialAppBar.displayName);
  const { t } = useTranslation();

  const logoutButton = hasLogoutButton ? props.logoutButton : undefined;

  const actionProps = {
    alloWMultilanguages,
    customerWizardRoute,
    help,
    exit,
    phone,
    logoutButton,
    helpType,
    configByName,
  };

  const [height, setHeight] = useState(0);

  const ref = useRef(null);

  useLayoutEffect(() => {
    setHeight(ref.current.offsetHeight);
  }, []);

  return (
    <>
      <AppBar
        variant={variant}
        elevation={elevation}
        position={position}
        color={color}
        className={classnames(MaterialAppBar.displayName, className)}
      >
        <MaterialContainer sx={{ boxShadow: containerBoxShadow }} maxWidth={containerMaxWidth}>
          <MaterialToolbar ref={ref} disableGutters={disableGutters} sx={{ height: 'auto' }}>
            {showAtLeastOneLogo && (
              <LogosWrapper flex="100" height={height}>
                {logo &&
                  (isLogoClickable ? (
                    <MaterialLink
                      routerLink
                      className={classnames('logo-wrapper', { mainCentered: isLogoCentered })}
                      tabIndex="0"
                      href="/"
                      name={MaterialAppBar.displayName}
                    >
                      {logo}
                    </MaterialLink>
                  ) : (
                    <div className={classnames('logo-wrapper', { mainCentered: isLogoCentered })}>{logo}</div>
                  ))}
                {secondaryLogo && <div className="logo-wrapper secondaryCentered">{secondaryLogo}</div>}
              </LogosWrapper>
            )}
            {!!menu && (
              <Content>
                {menu.map((item) => {
                  if (Object.prototype.hasOwnProperty.call(item, 'submenu')) {
                    return (
                      <SubMenuWrapper key={item.id}>
                        <MenuWrapper height={height}>
                          <MaterialTypography
                            padding={'0 30px 5px 0'}
                            className="menuLinkHover"
                            margin={'5px 40px 0 40px'}
                            variant="h4"
                            color={'primary'}
                          >
                            {t(`${configByName}.menu.${item.id}.label`)}
                          </MaterialTypography>
                        </MenuWrapper>

                        <div className="subMenu">
                          {item.submenu.map((el) => {
                            return (
                              <NavLinkStyled
                                key={el.id}
                                to={interpolateString(el)}
                                data-testid={`${MaterialAppBar.displayName}-${el.id}`}
                              >
                                {typeof el.leftAdornment === 'function' && el.leftAdornment()}
                                <MaterialTypography variant="h4" color={'primary'}>
                                  {t(`${configByName}.menu.${item.id}.submenu.${el.id}.label`)}
                                </MaterialTypography>
                                {typeof el.rightAdornment === 'function' && el.rightAdornment()}
                              </NavLinkStyled>
                            );
                          })}
                        </div>
                      </SubMenuWrapper>
                    );
                  }

                  return (
                    <MenuWrapper key={item.id} height={height} data-testid={`${MaterialAppBar.displayName}-${item.id}`}>
                      <NavLinkStyled to={interpolateString(item)}>
                        <MaterialTypography variant="h4" color={'primary'}>
                          {t(`${configByName}.menu.${item.id}.label`)}
                        </MaterialTypography>
                      </NavLinkStyled>
                    </MenuWrapper>
                  );
                })}
              </Content>
            )}
            {!!children && <MenuWrapper height={height}>{children}</MenuWrapper>}
            {alloWMultilanguages && !actions && (
              <MenuWrapper height={height}>
                <LanguageSelect
                  onChange={() => {
                    setTimeout(() => {
                      window.location.reload();
                    }, 100);
                  }}
                />
              </MenuWrapper>
            )}
            {!!logoutButton && !actions && <MenuWrapper height={height}>{logoutButton}</MenuWrapper>}
            {actions && (
              <MenuWrapper height={height}>
                <MaterialAppBarActions {...actionProps} />
              </MenuWrapper>
            )}
          </MaterialToolbar>
        </MaterialContainer>
      </AppBar>

      {position === 'fixed' && <MaterialToolbar />}
    </>
  );
};

MaterialAppBar.displayName = 'MaterialAppBar';

MaterialAppBar.propTypes = {
  children: PropTypes.node,
  buttons: PropTypes.node,
  name: PropTypes.string,
  logoutButton: PropTypes.node,
  containerMaxWidth: PropTypes.any,
  containerBoxShadow: PropTypes.string,
};

export default withRouter(React.memo(withWidget(MaterialAppBar)));
